export interface DealerAccessV2Record {
  search: string;
  addPanelDealerId: string | null;
  editPanelDealerId: string | null;
  editPanelLimited: boolean;
  removeConfirmDealerId: string | null;
  isReadMoreOpen: boolean;
  cardError: { id: string; messageLangKey: string } | null;
}

export const initialDealerAccessV2Record: DealerAccessV2Record = {
  search: '',
  addPanelDealerId: null,
  editPanelDealerId: null,
  editPanelLimited: false,
  removeConfirmDealerId: null,
  isReadMoreOpen: false,
  cardError: null,
};

export const GENERIC_ERROR_KEY = 'web.dealer_access.error.something_went_wrong';
export const TRY_AGAIN_KEY = 'web.dealer_access.error.try_again_button';
